import React from 'react';
import styled, { css } from 'styled-components';
import { forDesktop, forIE, forMidWideScreens } from '@westwing/ui-kit/breakPoints';
import { Direction, StyledArrowIcon } from '@westwing/ui-kit/Icons/StyledIcons';
import { BellaTestIds } from 'Common/qaIds';
import { llpBackToTopBreakpoint } from 'Client/components/GlobalStyles/theme';

const Wrapper = styled.div<{ show: boolean; p100IncreasedDesktopPageWidth?: boolean }>`
    grid-area: back;
    display: none;
    height: 100%;
    padding-top: 200vh;
    padding-left: 5px;

    ${({ show }) =>
        show
            ? css`
                  ${forDesktop`
                      display: block;
                  `}
              `
            : ''}

    ${({ p100IncreasedDesktopPageWidth, theme }) =>
        p100IncreasedDesktopPageWidth
            ? css`
                  ${forDesktop`
                     position: absolute;
                     right: 26px;
                     z-index: ${theme.zIndexBelowContentOverlay};
                 `}

                  ${forMidWideScreens`
                        right: 50px;
                  `}

                  ${llpBackToTopBreakpoint`
                        right: -12px;
                  `}
              `
            : ''}

    ${forIE`
        -ms-grid-row : 2;
        -ms-grid-row-span : 1;
        -ms-grid-column : 3;
        -ms-grid-column-span : 1;
    `}
`;

const Button = styled.button`
    position: sticky;
    top: calc(100vh - 60px);
    border: 1px solid ${({ theme }) => theme.colors.charcoal100};
    width: ${({ theme }) => theme.buttonHeight};
    height: ${({ theme }) => theme.buttonHeight};
    cursor: pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    padding-bottom: 4px;

    ${forIE`
        display: none;
    `}
`;

interface Props {
    show: boolean;
    p100IncreasedDesktopPageWidth?: boolean;
}

const BackToTopButton: React.FC<Props> = ({ show, p100IncreasedDesktopPageWidth }) => {
    const handleScrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth',
        });
    };

    return (
        <Wrapper
            show={show}
            data-testid={BellaTestIds.backToTopButton}
            p100IncreasedDesktopPageWidth={p100IncreasedDesktopPageWidth}
        >
            <Button
                onClick={e => {
                    e.stopPropagation();
                    handleScrollToTop();
                }}
            >
                <StyledArrowIcon direction={Direction.Up} size={9} />
            </Button>
        </Wrapper>
    );
};

export default BackToTopButton;
